import { notFound } from 'next/navigation';
import type { ReactNode } from 'react';
import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';

import type { Product } from '@libs/common-next';

type AlgoliaNoResultsBoundaryProps = {
    children: ReactNode;
    products: Product[];
    isCategoryActive: boolean;
};

export default function AlgoliaNoResultsBoundary({
    children,
    products,
    isCategoryActive,
}: AlgoliaNoResultsBoundaryProps) {
    const { results, status } = useInstantSearch();
    const { items } = useCurrentRefinements();
    const isRealResults = !results.__isArtificial;

    // Current date is outside of category date range
    if (isRealResults && !isCategoryActive) {
        console.info(`[PLP] 404: Category is inactive.`);
        return notFound();
    }

    const noResult = items.length === 0 && products.length === 0;
    const isSearchPending = status === 'loading' || status === 'stalled';

    if (isRealResults && noResult && !isSearchPending) {
        console.info(`[PLP] 404: Category did not return product results.`);
        return notFound();
    }

    return children;
}
